document.addEventListener('DOMContentLoaded', () => {
  const offer = document.querySelector('[data-wm-global-offer]');
  if (!offer || sessionStorage.getItem('wmOfferClosed') === '1') {
    if (offer) offer.hidden = true;
    return;
  }
  const goal = 500000;
  const money = cents => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 }).format(cents / 100);
  const paint = total => {
    const percent = Math.min(100, Math.max(0, Math.round(total * 100 / goal)));
    offer.querySelector('[data-wm-global-percent]').textContent = `${percent}%`;
    offer.querySelector('[data-wm-global-bar]').style.width = `${percent}%`;
    const message = offer.querySelector('[data-wm-global-message]');
    if (total >= goal) {
      message.innerHTML = '<strong>¡Beneficio desbloqueado!</strong> Envío gratis + termo grabado.';
      offer.classList.add('is-ready');
    } else if (total > 0) {
      message.textContent = `Te faltan ${money(goal - total)} para envío gratis + termo grabado.`;
    }
  };
  paint(Number(offer.dataset.total || 0));
  fetch('/cart.js').then(response => response.json()).then(cart => paint(cart.total_price)).catch(() => {});
  offer.querySelector('[data-wm-offer-close]').addEventListener('click', () => {
    offer.hidden = true;
    sessionStorage.setItem('wmOfferClosed', '1');
  });
});
